<ul class="nav nav-tabs" role="tablist">
  <li class="nav-item">
    <a class="nav-link active" id="identificacao-tab" data-toggle="tab" href="#identificacao" role="tab"
      aria-controls="identificacao" aria-selected="true">Identificação do Termo Aditivo</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" id="vigencia-tab" data-toggle="tab" href="#vigencia" role="tab" aria-controls="vigencia"
      aria-selected="true">Vigência</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" id="financeiro-tab" data-toggle="tab" href="#financeiro" role="tab" aria-controls="financeiro"
      aria-selected="true">Financeiro</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" id="exigencia-tab" data-toggle="tab" href="#exigencia" role="tab" aria-controls="exigencia"
      aria-selected="true">Exigências e Cláusulas</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" id="publicacao-tab" data-toggle="tab" href="#publicacao" role="tab" aria-controls="publicacao"
      aria-selected="true">Publicações</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" id="conclusao-tab" data-toggle="tab" href="#conclusao" role="tab" aria-controls="conclusao"
      aria-selected="true">Conclusão</a>
  </li>
</ul>
<div class="tab-content">
  <div class="tab-pane fade show active" id="identificacao" role="tabpanel" aria-labelledby="identificacao-tab">
    <div class="row">
      <div class="col-6">
        <p-fieldset legend="Identificação do Termo Aditivo">
          <div class="row">
            <div class="col-md-4 form-group form-group-sm">
              <label for="TermoAditivoCodigo" class="required">Código Termo Aditivo</label>
              <input type="text" class="form-control" id="TermoAditivoCodigo" [(ngModel)]="arquivo.TermoAditivoCodigo"
                [ngModelOptions]="{standalone: true}" unmask="typed" [imask]="imaskQtd"
                [style]="{ width: 'calc(100% - 32px)', float: 'left' }">
              <button class="btn btn-sm btn-outline-secondary float-right" type="button" (click)="atribuirCodigo()"
                style="height: 35px; border-bottom-left-radius: 0px;  border-top-left-radius: 0px;">
                <i class="fa fa-sync"></i>
              </button>
            </div>
            <div class="col-md-5 form-group form-group-sm">
              <label for="TermoAditivoNumero" class="required d-block">Termo Aditivo / Ano</label>
              <select id="aditivoId" class="form-control" [(ngModel)]="arquivo.aditivoId"
                [ngModelOptions]="{standalone: true}" (change)="atribuirAditivo()">
                <option *ngFor="let item of listaAditivo" [ngValue]="item.id">
                  {{item.numero}}/{{item.ano}}
                </option>
              </select>
            </div>
            <div class="col-md-3 form-group form-group-sm">
              <label for="TermoAditivoValor" class="required">Valor</label>
              <input type="text" class="form-control text-right" id="TermoAditivoValor"
                [(ngModel)]="arquivo.TermoAditivoValor" [ngModelOptions]="{standalone: true}" unmask="typed"
                [imask]="imaskConfig">
            </div>
          </div>
          <div class="row">
            <div class="col-12 form-group form-group-sm">
              <label for="TermoAditivoObjeto" class="required">Objeto do termo aditivo</label>
              <textarea class="form-control" id="TermoAditivoObjeto" rows="5" [(ngModel)]="arquivo.TermoAditivoObjeto"
                [ngModelOptions]="{standalone: true}"></textarea>
            </div>
          </div>
        </p-fieldset>
        <p-fieldset legend="Justificativa">
          <div class="row mt-3">
            <div class="col-12">
              <div class="row col-form-label">
                <label class="required float-left col-9">
                  Há no procedimento justificativa para assinatura do termo aditivo?
                </label>
                <p-selectButton [options]="opcoesSimNao" optionValue="id" class="float-right col-3"
                  [(ngModel)]="arquivo.TermoAditivoJustificativaNao" [ngModelOptions]="{standalone: true}">
                  <ng-template let-opcao>
                    <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
                  </ng-template>
                </p-selectButton>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12" *ngIf="arquivo.TermoAditivoJustificativaNao === 'S'">
              <label for="JustificativaApresentada" class="required">Justificativa apresentada</label>
              <textarea class="form-control" id="JustificativaApresentada" rows="5"
                [(ngModel)]="arquivo.TermoAditivoJustificativaSim.JustificativaApresentada"
                [ngModelOptions]="{standalone: true}"></textarea>
            </div>
          </div>
        </p-fieldset>
      </div>
      <div class="col-6">
        <p-fieldset legend="Tipos de Aditivo">
          <div class="row">
            <div class="col-12">
              <table class="table table-eddy table-sm">
                <tbody>
                  <tr *ngFor="let item of arquivo.listTipos">
                    <td>
                      <div class="checkbox checbox-switch switch-primary">
                        <label>
                          <input [(ngModel)]="item.marcado" [ngModelOptions]="{standalone: true}" type="checkbox" />
                          <span></span>
                        </label>
                      </div>
                    </td>
                    <td>{{funcaoService.obterNomePorChave(listTipos, item.id)}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </p-fieldset>
      </div>
    </div>
  </div>
  <div class="tab-pane fade" id="vigencia" role="tabpanel" aria-labelledby="vigencia-tab">
    <p-fieldset legend="Vigência">
      <div class="row">
        <label class="required col-4 col-form-label">
          Data do início da vigência do termo aditivo
        </label>
        <p-calendar (onFocus)="onFocusDate()" [(ngModel)]="arquivo.TermoAditivoInicioVigenciaDt"
          [ngModelOptions]="{standalone: true}" inputStyleClass="form-control col-auto" dataType="string"
          dateFormat="dd/mm/yy" [showOnFocus]="true" [showButtonBar]="true" [showIcon]="true">
        </p-calendar>
      </div>
      <div class="row mt-2">
        <label class="required col-4 col-form-label">
          Data do término da vigência do termo aditivo
        </label>
        <p-calendar (onFocus)="onFocusDate()" [(ngModel)]="arquivo.TermoAditivoFimVigenciaDt"
          [ngModelOptions]="{standalone: true}" inputStyleClass="form-control col-auto" dataType="string"
          dateFormat="dd/mm/yy" [showOnFocus]="true" [showButtonBar]="true" [showIcon]="true">
        </p-calendar>
      </div>
      <div class="row mt-2">
        <label class="required col-4 col-form-label">
          Data da assinatura do termo aditivo
        </label>
        <p-calendar (onFocus)="onFocusDate()" [(ngModel)]="arquivo.TermoAditivoAssinaturaDt"
          [ngModelOptions]="{standalone: true}" inputStyleClass="form-control col-auto" dataType="string"
          dateFormat="dd/mm/yy" [showOnFocus]="true" [showButtonBar]="true" [showIcon]="true">
        </p-calendar>
      </div>
    </p-fieldset>
  </div>
  <div class="tab-pane fade" id="financeiro" role="tabpanel" aria-labelledby="financeiro-tab">
    <p-fieldset legend="Nota de Empenho/Documento Similar">
      <div class="row mt-3">
        <div class="col-12">
          <div class="row col-form-label">
            <label class="required float-left col-9">
              Houve emissão de Nota de Empenho/Documento Similar por causa do Termo Aditivo?
            </label>
            <p-selectButton [options]="opcoesSimNao" optionValue="id" class="float-right col-3"
              [(ngModel)]="arquivo.NotaEmpenhoDocSimilarNao" [ngModelOptions]="{standalone: true}">
              <ng-template let-opcao>
                <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
              </ng-template>
            </p-selectButton>
          </div>
        </div>
      </div>
      <lib-licitacao-audesp-empenho [entidade]="arquivo" [campo]="'NotaEmpenhoDocSimilarSim'"
        *ngIf="arquivo.NotaEmpenhoDocSimilarNao === 'S'">
      </lib-licitacao-audesp-empenho>
    </p-fieldset>
  </div>
  <div class="tab-pane fade" id="exigencia" role="tabpanel" aria-labelledby="exigencia-tab">
    <p-fieldset legend="Garantia e Autorização">
      <div class="row mt-2">
        <div class="col-12">
          <div class="row col-form-label">
            <label class="required float-left col-5">
              Possui exigência de garantia?
            </label>
            <p-selectButton [options]="opcoesSimNao" optionValue="id" class="float-right col-3"
              [(ngModel)]="arquivo.PossuiExigenciaGarantia" [ngModelOptions]="{standalone: true}">
              <ng-template let-opcao>
                <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
              </ng-template>
            </p-selectButton>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-12">
          <div class="row col-form-label">
            <label class="required float-left col-5">
              Existe autorização para assinatura do termo aditivo?
            </label>
            <p-selectButton [options]="opcoesSimNao" optionValue="id" class="float-right col-3"
              [(ngModel)]="arquivo.AutorizacaoAssinaturaNao" [ngModelOptions]="{standalone: true}">
              <ng-template let-opcao>
                <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
              </ng-template>
            </p-selectButton>
          </div>
          <div class="row mt-2" *ngIf="arquivo.AutorizacaoAssinaturaNao === 'S'">
            <label class="required col-5 col-form-label">
              Data da Autorização
            </label>
            <p-calendar (onFocus)="onFocusDate()"
              [(ngModel)]="arquivo.AutorizacaoAssinaturaSim.TermoAditivoAutorizacaoDt"
              [ngModelOptions]="{standalone: true}" inputStyleClass="form-control col-auto" dataType="string"
              dateFormat="dd/mm/yy" [showOnFocus]="true" [showButtonBar]="true" [showIcon]="true">
            </p-calendar>
          </div>
        </div>
      </div>
    </p-fieldset>
  </div>
  <div class="tab-pane fade" id="publicacao" role="tabpanel" aria-labelledby="publicacao-tab">
    <p-fieldset legend="Data da publicação do Ajuste">
      <div class="row">
        <label class="required col-12 col-form-label">
          Houve publicação do Ajuste em veículos de comunicação?
        </label>
        <p-selectButton [options]="opcoesSimNao" optionValue="id" class="col-12"
          [(ngModel)]="arquivo.TermoAditivoPublicacaoNao" [ngModelOptions]="{standalone: true}">
          <ng-template let-opcao>
            <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
          </ng-template>
        </p-selectButton>
      </div>
      <lib-licitacao-audesp-publicacao [entidade]="arquivo" [campo]="'TermoAditivoPublicacaoSim'"
        *ngIf="arquivo.TermoAditivoPublicacaoNao === 'S'"></lib-licitacao-audesp-publicacao>
    </p-fieldset>
  </div>
  <div class="tab-pane fade" id="conclusao" role="tabpanel" aria-labelledby="conclusao-tab">
    <lib-licitacao-audesp-termo-ciencia [entidade]="arquivo" [campo]="'TermoCienciaContratantes'"
      [titulo]="'Responsável pelo Termo Aditivo - parte Contratante'">
    </lib-licitacao-audesp-termo-ciencia>
    <lib-licitacao-audesp-termo-ciencia [entidade]="arquivo" [campo]="'TermoCienciaContratados'"
      [titulo]="'Responsável pelo Termo Aditivo - parte Contratado'">
    </lib-licitacao-audesp-termo-ciencia>
  </div>
</div>